import React from "react";
import { I18n } from "react-redux-i18n";
import { PRODUCT_IMAGE_BASE_URL } from "../../config";
const CircleImage = ({ src, size, alt }) => {
  const alt_attribute = alt ? alt : I18n.t("no_image");
  let src_attribute = src ? src : require("../../styles/images/no_image.png");
  if (src.indexOf("https") === -1 && src.indexOf("base64") === -1) {
    src_attribute = `${PRODUCT_IMAGE_BASE_URL}/${size}_${src}`;
  }
  return <img image-orientation="from-image" src={src_attribute} alt={alt_attribute} />;
};
export default CircleImage;
